import { dayjs } from "@outschool/time";
import { IntegrationCategory, useTrackEvent } from "@outschool/ui-analytics";
import { useCallback } from "react";
import { useSession } from "../providers/SessionProvider";

const TRACK_EVENT_NAME = "Learner Created";

export function useTrackLearnerCreated() {
  const trackEvent = useTrackEvent(IntegrationCategory.Advertising);
  const { currentUser } = useSession();

  const trackLearnerCreated = useCallback(
    (properties?: Record<string, unknown>) => {
      if (properties) {
        trackEvent(TRACK_EVENT_NAME, properties);
      } else {
        if (currentUser) {
          const isNewUser = dayjs()
            .subtract(2, "hours")
            .isBefore(currentUser.created_at);

          if (isNewUser) {
            trackEvent(TRACK_EVENT_NAME, {
              is_first_learner: currentUser.children.length === 0,
              parent_id: currentUser.uid,
            });
          }
        }
      }
    },
    [trackEvent, currentUser],
  );

  return trackLearnerCreated;
}
